import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-classify/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-classify/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-classify/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-classify/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-classify/detail',
    method: 'get',
    params: { id }
  })
}
